import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const FloatingFormContext = /*#__PURE__*/createContext(undefined);
export const FloatingFormProvider = ({
  formStylesOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(FloatingFormContext.Provider, {
    value: {
      formStylesOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `FloatingForm` component.
 * Note: The context is only available when the `FloatingForm` component is rendered as an ancestor.
 * @returns FloatingFormContext - The context for the `FloatingForm` component.
 * @returns FloatingFormContext.formStylesOverrides - Style overrides to be applied to the `Popover` component.
 */
export const useFloatingFormContext = () => {
  const floatingFormContext = useContext(FloatingFormContext);
  return floatingFormContext;
};